import { ClerkProvider } from '@clerk/clerk-react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { readConfig } from './lib/env'
import './styles/global.css'

const root = document.getElementById('root')
if (!root) throw new Error('index.html is missing #root')

try {
  const config = readConfig(import.meta.env as unknown as Record<string, string | undefined>)

  createRoot(root).render(
    <StrictMode>
      <ClerkProvider publishableKey={config.clerkPublishableKey} afterSignOutUrl="/">
        <BrowserRouter>
          <App apiBaseUrl={config.apiBaseUrl} />
        </BrowserRouter>
      </ClerkProvider>
    </StrictMode>,
  )
} catch (error) {
  // A missing env var must be obvious at boot, not a blank page with a console warning.
  root.innerHTML = `<div class="center-panel"><h1>Detachly is not configured</h1><p class="muted">${
    error instanceof Error ? error.message : 'Unknown configuration error.'
  }</p></div>`
}
